import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {esNormativaV2} from '../../../../utils/normativa.utils'

export default function FilaDistritoEmisor() {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)

  if (!esNormativaV2(datosEmisor)) return null

  const nombre = `${datosEmisor?.distritonombre ?? ''}`.trim()
  const codigo = `${datosEmisor?.distrito ?? ''}`.trim()

  if (!nombre && !codigo) return null

  return (
    <tr>
      <td>Distrito:</td>
      <td>{nombre ? nombre.toUpperCase() : codigo}</td>
    </tr>
  )
}
